import React from 'react';
import { Label } from '../Label';
export const ClickAndCollectLabel = () => (React.createElement(Label, { icon: "ClickCollect", backgroundColor: "red100", textColor: "red700", iconSize: "22px", padding: "3.5px 8px 3.5px 8px" }, "Click & Collect"));
